<template>
    <div id="messageContainer" class="messageContainer">
        <intro v-if="(messages.length <= 0) && (this.start.value == undefined) && (this.start.text == undefined)"
            :logo="logo" :brand="brand" :welcome="welcome" :action="action" :button="button">
        </intro>       
        <div v-for=" message  in  messages " :key="message.id" class="messages clearfix" :data-direction="message.direction"
            :data-type="message.type">
            <!-- SIMPLE TYPES -->
            <simpleText v-if="message.type === 'simpleText'" :type="message.type" :direction="message.direction"
                :content="message.content.text"></simpleText>
            <simpleText v-if="message.type === 'html'" :type="message.type" :direction="message.direction"
                :content="message.content.html"></simpleText>
            <suggestions v-if="message.type === 'suggestions' || message.type === 'buttons'" :type="message.type"
                :title="message.content.title" :content="message.content"></suggestions>
            <tablecard v-if="message.type === 'tablecard'" :title="message.gridtext" :columns="message.gridColumn"
                :content="message.content"></tablecard>
            <register v-if="message.type === 'register'" :content="message.content"></register>
            <linkSuggestion v-if="message.type === 'linkSuggestion'" :content="message.content"></linkSuggestion>
            <!-- END SIMPLE TYPES -->

            <!-- CARD TYPES -->
            <simpleCard v-if="message.type === 'basicCard'" :content="message.content"></simpleCard>
            <mediaCard v-if="message.type === 'mediacard'" :content="message.content"></mediaCard>
            <carouselCard v-if="message.type === 'simpleCarousel' || message.type === 'carousel'"
                :cards-list="message.content.items" :message-type="message.type"></carouselCard>
            <!-- END CARD TYPES -->

            <!-- Attachments type -->
            <attachment v-if="message.type === 'attachments'" :attachments="message.content.attachments"
                :post-attachments="postAttachments" :id="message.id"></attachment>

            <!-- Location type -->
            <location v-if="message.type === 'location'" :content="message.content"></location>

            <!-- List type -->
            <list v-if="message.type === 'listitems'" :content="message.content"></list>

            <!-- Question types -->
            <audioQuestion v-if="message.type === 'audio-question'" :content="message.content"></audioQuestion>
            <videoQuestion v-if="message.type === 'video-question'" :content="message.content"></videoQuestion>
            <multipleQuestion v-if="message.type === 'multiple-question'" :id="message.id" :content="message.content">
            </multipleQuestion>
            <singleQuestion v-if="message.type === 'single-question'" :id="message.id" :content="message.content">
            </singleQuestion>
            <ratingQuestion v-if="message.type === 'rating-question'" :id="message.id" :content="message.content">
            </ratingQuestion>
        </div>
        <!-- Typing loader -->
        <typing v-show="typing === true"></typing>
        <div @click="toBottom" class="toBottom" v-show="showScrollBottom">
            <div class="angle"></div>
        </div>
    </div>
</template>

<script>
/** Async handlers **/
const axios = require('axios')
import Echo from 'laravel-echo'
import { uuid } from 'vue-uuid'
/** Message Types **/

import {
    /* Start Simple */
    Suggestions,
    SimpleText,
    LinkSuggestion,
    Register,
    Tablecard,
    /* End Simple */
    /* Start question */
    AudioQuestion,
    MultipleQuestion,
    RatingQuestion,
    SingleQuestion,
    VideoQuestion,
    /* End question */
    /* Start Cards */
    SimpleCard,
    MediaCard,
    CarouselCard,
    /* End Cads */
    Attachment,
    Location,
    List,
    Intro,
    Typing
} from 'maiamessagetypes'

/** External utils, const and functions **/
import {
    getSessionId
} from './repositories/session.js'
import {
    encodeFiles
} from './repositories/encodeFiles.js'

import {
    getCookie, setCookie
} from './repositories/cookies.js'

import {
    getLocalStorageItem, setLocalStorageItem
} from './repositories/localStorage.js'

import {
    USER_ID_STORAGE,
    MESSAGES_STORAGE
} from '@/utils/constants.js'
import {
    GetOffsetHeightElem,
    Debounce
} from '@/utils/utils.js'
 
// PAYLOAD FOR TEST
/*
import {
    basicCard,
    carousel,
    simpleCarousel,
    linkSuggestion,
    listitems,
    mediacard,
    simpleText,
    simpleTextIncoming,
    html,
    suggestions,
    buttons,
    tablecard,
    register,
    location,
    audioQuestion,
    videoQuestion,
    videoMediaCard,
    imageMediaCard,
    multipleQuestion,
    singleQuestion,
    ratingQuestion
} from '@/utils/payloads.js'
// */

export default {
    name: 'messagecontainer',
    props: {
        platform: String,
        platformId: String,
        logo: String,
        brand: String,
        language: String,
        user: Object,
        websocket: String,
        domain: String,
        start: Object,
        delay: String,
        notificationKey: String,
        welcome: String,
        action: String,
        button: String,
        reset: String,
        avatarvideo: Boolean
    },
    components: {
        Typing,
        // Message types
        // Simple
        Tablecard,
        Suggestions,
        SimpleText,
        Register,
        LinkSuggestion,
        // Cards
        MediaCard,
        SimpleCard,
        CarouselCard,
        List,
        Intro,
        Attachment,
        Location,

        AudioQuestion,
        VideoQuestion,
        MultipleQuestion,
        SingleQuestion,
        RatingQuestion
    },
    data() {
        return {
            url: '',
            typing: false,
            needScroll: false,
            messagesLoaded: false,
            messages: [],
            sessionId: null,
            showScrollBottom: false,
            avatarVideoIsPlaying: false
        }
    },
    computed: {
        messagesStorageKey: function () {
            return MESSAGES_STORAGE + '-' + this.platformId + '-' + this.sessionId + '-' + this.user.id
        }
    },
    created() {
        this.setupUser()
        this.setupSession()
        this.setupMessages()
        this.url =
            window.location.protocol +
            '//' +
            this.domain +
            '/api/ingestion/' +
            this.platform +
            '/' +
            this.platformId
    },
    mounted() {
        let self = this;

        // Set the height of the message container based on the height of the header and footer
        this.resizeMessageContainer()
        this.initResizeWatcher()
        // Set up websocket
        this.setupWebsocket(this.notificationKey, this.user.notificationId)

        // Set welcome message
        if (this.start.value !== null) {
            let text = (this.start.text == undefined) ? 'Ciao!' : this.start.text
            
            if (text != '[hidden]') {
                this.pushMessageText(text)
            }

            this.postMessage(this.start.value, text)
            this.typing = false
        }

        this.$root.$on('sendStart', () => {
            if(self.messages == 0){
                this.$root.$emit('send_message', 'Ciao!','Ciao!');
            }            
        });

        // Toggle scroll to bottom 
        // Get the height of header plus footer
        const headeFooterH = GetOffsetHeightElem('.header') + GetOffsetHeightElem('.footer')
        document
            .getElementById('messageContainer')
            .addEventListener('scroll', () => {
                var msgContainer = document.getElementById('messageContainer')
                if (msgContainer.scrollTop < msgContainer.scrollHeight - msgContainer.offsetHeight - headeFooterH) {
                    this.showScrollBottom = true
                } else {
                    this.showScrollBottom = false
                }
            })

        if (this.messagesLoaded) {
            this.messagesLoaded = false
            this.toBottom()
        }

        this.$root.$on('avatarvideo_playing', (playing) => {
            if(playing){
                this.avatarVideoIsPlaying = true;
                //console.log('Messages: avatarvideo_playing is playing');
            }else{
                this.avatarVideoIsPlaying = false;
                //console.log('Messages: avatarvideo_playing has stop');
            }
        }); 

        // Event for every message sent
        this.$root.$on('send_message', (messageValue, messageText, latitude = null, longitude = null) => {
            if (self.messages.length > 0) {
                // if(this.avatarvideo && !this.avatarVideoIsPlaying){
                //     this.$root.$emit('avatarvideo_playing', true);
                // }
                let normalizedMessageText = self.normalizeForInputComparison(messageText);

                let lastMessage = self.messages[self.messages.length - 1];

                // Nota bene: per ora implementiamo solo i buttons poi vedremo come fare per gli altri payload
                if (lastMessage.type === 'buttons') {

                    let button = lastMessage.content.buttons.find(function (button) {
                        return (self.normalizeForInputComparison(button.title) == normalizedMessageText);
                    });

                    if (button) {
                        messageValue = button.value;
                        messageText = button.title;
                    }
                }
            }

            self.pushMessageText(messageText)
            self.postMessage(messageValue, messageText, latitude, longitude)
            self.typing = true
        })
        // Event on selecting file form the chatFooter
        this.$root.$on('selecting_files', files => {
            const uuidv1 = require('uuid/v1')

            encodeFiles(files, this, function (attachments, self) {
                let message = {
                    id: uuidv1(),
                    direction: 'outgoing',
                    type: 'attachments',
                    content: {
                        attachments: attachments
                    }
                }

                self.pushMessage(message)

                self.$root.$emit('selected_files')

                self.needScroll = true
            })
        })
        // Event on loading a audio/video message
        this.$root.$on('sending_audio_video_file', files => {
            const uuidv1 = require('uuid/v1')

            encodeFiles(files, this, function (attachments, self) {
                let message = {
                    id: uuidv1(),
                    direction: 'outgoing',
                    type: 'attachments',
                    content: {
                        attachments: attachments
                    }
                }

                self.pushMessage(message)
                self.needScroll = true
                self.$nextTick(function () {
                    self.$root.$emit('autosend_' + message.id)
                })
            })
        })
        /* Events used in backend */
        this.$root.$on('deleted_message', () => {
            self.typing = false
        })
    },
    updated() {
        if (this.needScroll) {
            const self = this
            this.$nextTick(function () {
                self.scrollToLast()
                self.needScroll = false
            })
        }
    },
    methods: {
        initResizeWatcher() {
            const self = this
            window.addEventListener('resize', Debounce(function () {
                self.$nextTick(function () {
                    self.resizeMessageContainer()
                })
            }, 0))
        },
        resizeMessageContainer() {
            const frameH = document.getElementById('header').offsetHeight + document.getElementById('footer').offsetHeight
            document.getElementById('messageContainer').setAttribute('style', 'height:calc(100% - ' + frameH + 'px)')
        },
        setupUser() {
            this.setUserId()
            this.user.notificationId = this.user.notificationId ? this.user.notificationId : this.user.id
            if (
                this.user.fullName == undefined &&
                (this.user.firstName == undefined || this.user.lastName == undefined)
            ) {
                this.user.fullName = 'Utente Anonimo'
                this.user.firstName = 'Utente'
                this.user.lastName = 'Anonimo'
            }
        },
        setupSession() {
            this.sessionId = getSessionId()
        },
        setupMessages() {
            let messages = [];

            try {
                if (this.reset === 'true') {
                    setLocalStorageItem(this.messagesStorageKey, []);
                } else if (!isNaN(this.reset)) {
                    let resetMinutes = parseInt(this.reset);
                    if (resetMinutes > 0) {
                        let resetCookieName = 'MaiaResetLocalStorage';
                        if (getCookie(resetCookieName) == '') {
                            setLocalStorageItem(this.messagesStorageKey, []);
                        } else {
                            setCookie(resetCookieName, 'true', resetMinutes);
                        }
                    }
                }

                let payload = getLocalStorageItem(this.messagesStorageKey)
                messages = JSON.parse(payload)
            } catch (error) {
                // eslint-disable-next-line
            }

            // Test payloads
            // messages = [carousel]
            // /Test payloads

            if (Array.isArray(messages) && messages.length > 0) {
                this.messages = messages
                this.messagesLoaded = true
                window.parent.postMessage({ 'message': 'maiaChatSmallscreen' }, '*')
            }
        },
        setUserId() {
            // Se viene passato un userId dal widget, usa quello
            if (this.user.id) {
                setLocalStorageItem(USER_ID_STORAGE, this.user.id);
            } else {
                // Se c'è già un userId nel local storage, usa quello
                let currentUserId = getLocalStorageItem(USER_ID_STORAGE)
                if (currentUserId != null) {
                    this.user.id = currentUserId
                } else {
                    // Altrimenti crea un nuovo userId e usalo
                    this.user.id = uuid.v1()
                    setLocalStorageItem(USER_ID_STORAGE, this.user.id)
                }
            }
        },
        setupWebsocket(notificationKey, notificationId) {
            if (!this.websocket || !notificationKey || !notificationId) {
                return;
            }

            window.Pusher = require('pusher-js')

            notificationKey = notificationKey ? notificationKey : '839cd3c6becc13098f0b53e02777760648720ca4'

            window.Echo = new Echo({
                broadcaster: 'pusher',
                key: notificationKey,
                wsHost: this.websocket,
                enabledTransports: ['ws', 'wss'],
                forceTLS: true,
                disableStats: true
            })

            const self = this
            window.Echo.channel(`webchat.${notificationId}`).listen('.message.received', (event) => {
                if (typeof event.message.message !== 'undefined') {
                    self.messageReceived(event.message.message)
                }
            })
        },
        messageReceived(message) {
            this.pushMessage(message)
            this.needScroll = true
        },
        scrollToLast() {
            // Scroll at the beginning of the last message
            var container = document.getElementById('messageContainer')
            var lastMessage = document.querySelector('#messageContainer .messages:nth-last-child(3)')
            if (container && lastMessage) {
                container.scrollTop = lastMessage.offsetTop - 111 // Header height
            }
        },
        toBottom() {
            var container = document.getElementById('messageContainer')
            container.scrollTop = container.scrollHeight
        },
        displayResponse(response) {
            this.typing = true

            if ((typeof response.data.messages === 'undefined') || (response.data.messages.length === 0)) {
                this.typing = false
            } else {

                this.$root.$emit('messages-received', response.data.messages);

                if(!this.avatarvideo){
                    let intervalTime = 0
                    // Set interval time
                    if (this.delay === 'auto') {
                        for (let x = 0; x < response.data.messages.length; x++) {
                            if (response.data.messages[x].type === 'simpleText') {
                                intervalTime += response.data.messages[x].content.text.length * 10.5
                            } else if (response.data.messages[x].type === 'html') {
                                intervalTime += response.data.messages[x].content.html.length * 2
                            } else {
                                intervalTime += 800
                            }
                        }
                        // if the interval time is too long (over 800), set it at 800
                        intervalTime = Math.min(intervalTime, 800)
                    } else if (this.delay === 'false') {
                        intervalTime = 0
                    } else {
                        intervalTime = parseInt(this.delay)
                    }

                    let i = 0
                    let interval = setInterval(() => {
                        let messagesArr = response.data.messages
                        this.needScroll = true
                        this.typing = true
                        
                    
                        
                        this.pushMessage(messagesArr[i]);

                        i++
                        // if pushed all messages, stop the interval
                        if (messagesArr.length === i) {
                            clearInterval(interval)
                            this.typing = false
                        }
                    }, intervalTime);
                }else{
                    let maiaStart = setInterval(() => {
                        if(this.avatarVideoIsPlaying){   
                            clearInterval(maiaStart);
                            let messagesArr = response.data.messages
                            
                            for(let i = 0; i<messagesArr.length; i++){
                                this.pushMessage(messagesArr[i]);
                            }

                            this.needScroll = true
                            this.typing = false
                        }
                    }, 500);                   
                }            
            }
        },
        postMessage(messageValue, messageText, latitude = null, longitude = null) {
            let message = this.setMessage(messageValue, messageText, latitude, longitude)

            this.typing = true;

            let self = this
            axios
                .post(this.url, message)
                .then(function (response) {
                    self.displayResponse(response)
                })
                .catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.log(error)
                })
        },
        postAttachments(attachments, callback) {
            let message = this.setMessage(...Array(4), attachments)

            this.typing = true;

            let self = this
            axios
                .post(this.url, message, {
                    onUploadProgress: function (progressEvent) {
                        callback(progressEvent)
                    }
                })
                .then(function (response) {
                    self.displayResponse(response)
                })
                .catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.log(error)
                })
        },
        setMessage(messageValue = null, messageText = null, latitude = null, longitude = null, attachments = []) {
            let message = {
                driver: 'webchat',
                session: this.sessionId,
                user: {
                    id: this.user.id,
                    fullName: this.user.fullName,
                    firstName: this.user.firstName,
                    lastName: this.user.lastName,
                    email: this.user.email,
                    extra: this.user.extra
                },
                chat: {
                    id: this.platformId
                },
                message: {
                    interactive: false,
                    language: this.language,
                    text: messageText,
                    value: messageValue,
                },
                attachments: attachments,
                location: {
                    support: Boolean(navigator.geolocation),
                    latitude: latitude,
                    longitude: longitude,
                }
            }
            return message
        },
        pushMessageText(messageText) {
            const uuidv1 = require('uuid/v1')

            this.needScroll = true

            this.pushMessage({
                id: uuidv1(),
                direction: 'incoming',
                content: {
                    text: messageText
                },
                type: 'simpleText'
            })
        },
        pushMessage(message) {
            this.messages.push(message)
            setLocalStorageItem(this.messagesStorageKey, JSON.stringify(this.messages))
        },
        normalizeForInputComparison(text) {
            return text.normalize('NFD') // Normalizza
                .replace(/[\u0300-\u036f]/g, '') // Sostituisci lettere accentate
                .replace(/[^a-zA-Z0-9 ]/g, '') // Rimuovi non lettere, spazi e numeri
                .replace(/\s+/, ' ') // Sostituisci spazi multipli in singoli
                .trim()
                .toLowerCase();
        }
    }
}
</script>

<style lang="scss">
@import '~maiamessagetypes/dist/maia-message-types.css';

.messageContainer {
    width: 100%;
    height: calc(100% - 150px);
    max-width: 1000px;
    overflow-y: auto;
    overflow-x: hidden;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 20px;
    margin: 0 auto;
}

.toBottom {
    width: 30px;
    height: 30px;
    position: fixed;
    bottom: 15%;
    right: 10%;
    cursor: pointer;
    border-radius: 7px;
    background-size: 22px;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: #c1c1c1;
    background-image: url("/frontend/img/ico_scroll.svg");
}

.message {
    padding: 5px 14px;
    border-radius: 25px;
    min-width: 2vw;
    max-width: 90%;
    position: relative;
    margin-bottom: 14px;
    clear: both;

    a {
        color: inherit;
        text-decoration: underline;
    }

    &.incoming-message {
        border-top-right-radius: 0px;
        margin-left: 8%;
        float: right;
        clear: left;
    }

    &.outgoing-message {
        border-top-left-radius: 0px;
        margin-right: 8%;
        float: left;
        clear: right;
    }
}

.incoming-message {
    &:after {
        content: "";
        display: block;
        position: absolute;
        width: 10px;
        height: 10px;
        top: 0px;
        right: -5px;
        border-bottom: 5px solid transparent;
        border-right: 5px solid transparent;
    }
}

.outgoing-message {
    &:after {
        content: "";
        display: block;
        position: absolute;
        width: 10px;
        height: 10px;
        top: 0px;
        left: -5px;
        border-left: 5px solid transparent;
        border-bottom: 5px solid transparent;
    }
}
</style>
